/**
 * Trading identity for customer-facing documents.
 * Lives in organizations.settings.business so AI / sample-data settings are
 * not overwritten. Organization name remains the fallback legal name.
 */

export type OrgBusinessIdentity = {
  legalName: string;
  abn: string | null;
  address: string | null;
  email: string | null;
  phone: string | null;
  logoUrl: string | null;
};

export type OrgBusinessSettingsBlob = {
  legalName?: unknown;
  abn?: unknown;
  address?: unknown;
  email?: unknown;
  phone?: unknown;
  logoUrl?: unknown;
};

function text(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const t = value.trim();
  return t ? t : null;
}

export function parseOrgBusinessIdentity(
  orgName: string | null | undefined,
  settings: unknown,
): OrgBusinessIdentity {
  const blob =
    settings && typeof settings === "object" && settings !== null && "business" in settings
      ? ((settings as { business?: OrgBusinessSettingsBlob }).business ?? {})
      : {};
  const legalName = text(blob.legalName) ?? (orgName ?? "").trim() ?? "";
  return {
    legalName,
    abn: text(blob.abn),
    address: text(blob.address),
    email: text(blob.email),
    phone: text(blob.phone),
    logoUrl: text(blob.logoUrl),
  };
}

export function mergeOrgBusinessSettings(
  existing: Record<string, unknown> | null | undefined,
  business: OrgBusinessSettingsBlob,
): Record<string, unknown> {
  const prev =
    existing && typeof existing.business === "object" && existing.business !== null && !Array.isArray(existing.business)
      ? (existing.business as Record<string, unknown>)
      : {};
  return { ...(existing ?? {}), business: { ...prev, ...business } };
}
